var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main-page',{attrs:{"node":_vm.node}},[_c('article',[_c('NuxtContent',{staticClass:"content",attrs:{"document":_vm.node}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }